import { Monitor, Moon, Sun } from "lucide-react";
import { useState } from "react";

import { applyTheme, readTheme, saveTheme } from "@/shell/theme";
import type { ThemeChoice } from "@/shell/theme";
import { Button } from "@/ui/Button";

const NEXT: Record<ThemeChoice, ThemeChoice> = { system: "light", light: "dark", dark: "system" };
const LABEL: Record<ThemeChoice, string> = {
  system: "Theme: match the system",
  light: "Theme: light",
  dark: "Theme: dark",
};

/** One button that cycles system, light and dark; its label says which is on. */
export function ThemeToggle() {
  const [choice, setChoice] = useState<ThemeChoice>(readTheme);
  const Icon = choice === "light" ? Sun : choice === "dark" ? Moon : Monitor;
  return (
    <Button
      variant="ghost"
      size="sm"
      className="w-7 px-0"
      aria-label={LABEL[choice]}
      title={LABEL[choice]}
      onClick={() => {
        const next = NEXT[choice];
        saveTheme(next);
        applyTheme(next);
        setChoice(next);
      }}
    >
      <Icon aria-hidden="true" />
    </Button>
  );
}
